/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
      // // new content clear cache so user gets the new version
      // caches.keys().then((key) => {
      //   key.forEach((cache) => {
      //     caches.delete(cache).then()
      //   })
      // })
    },
    updated (registration) {
      console.log('New content is available; please refresh.')

      if (registration?.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      }

      // const question = 'New version available!' +
      //   '\n' + 'Click "OK" to reload the page.' +
      //   '\n' + 'Or "Cancel" to reload manually later.'
      //
      // if (registration?.waiting && window.confirm(question)) {
      //   registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      // }
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
